import { useEffect, useState } from "react"
import { Space } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { BaseButton } from "components/elements"
import { UploadFile } from "pages/common"

export const Upload = ({ className='', data, onChange, addYN, inputSize }) => {
  const [list, setList] = useState(data || [{}])

  const handleChange = (v, idx) => {
    setList([...list.slice(0, idx), v, ...list.slice(idx+1)])
  }

  const handleDelete = (idx) => {
    if (list.length > 1) setList([...list.filter((it,index) => index !== idx)])
    else setList([{}])
  }

  useEffect(() => {
    if (onChange) onChange(list)
  }, [list])

  return (<>
    <Space direction={'vertical'} className={className}>
      {list.map((it, idx) => (
        <UploadFile key={`${it?.name}${idx}`} inputSize={inputSize} fileName={it?.name} onChange={(v) => handleChange(v, idx)} onDelete={() => handleDelete(idx)} />
      ))}
      {
        !addYN ?
          <BaseButton icon={<PlusOutlined style={{ fontSize: '11px' }} />} label='추가하기' onClick={() => setList([...list, {}])} />
          : null
      }
    </Space>
  </>)
}
